/* eslint-disable @typescript-eslint/no-explicit-any */
export enum JourneyConstants {
  GET_INSURED_SESSION = '/dashboard/getInsuredSession',
  GET_INSURED_INDICATION = '/dashboard/getInsuredIndication',
  IND_SESSION_ID = 'indSessionId',
  APP_SESSION_ID = 'appSessionId',
  PORTAL_USER_ID = 'portalUserId',
  INDICATION_ID = 'indicationId',
  APPLICATION_ID = 'applicationId',
  APPLICATION_STATUS = 'applicationStatus',
}

export const JOURNEY_NAMES = {
  APPLY_IND_APP: 'apply-indication-app',
  APPLY_PHY_APP: 'apply-physician-app',
};

export const FORM_HOST = `${process.env.GATSBY_DIGITAL_JOURNEY_SERVICE}`;

const getJourney = (): any => {
  switch (process.env.GATSBY_ACTIVE_ENV) {
    case 'dev':
      return {
        [JOURNEY_NAMES.APPLY_IND_APP]: '6bdfe32e-290f-433b-9bd4-cc5a2223b6e9',
        [JOURNEY_NAMES.APPLY_PHY_APP]: '85ffa0fc-eb80-47b6-ab7e-364e79f5ef93',
      };
    default:
      return {
        [JOURNEY_NAMES.APPLY_IND_APP]: `${process.env.GATSBY_JOURNEY_IND_APP}`,
        [JOURNEY_NAMES.APPLY_PHY_APP]: `${process.env.GATSBY_JOURNEY_PHY_APP}`,
      };
  }
};

const getCompanyIdByEnv = (): string => {
  switch (process.env.GATSBY_ACTIVE_ENV) {
    case 'dev':
      return 'b158af4d-0903-4773-9021-83671bd4155b';
    default:
      return `${process.env.GATSBY_JOURNEY_COMPANY}`;
  }
};

export const JOURNEY_IDS = getJourney();
export const COMPANY = getCompanyIdByEnv();
